<!--Presents current news, events, and docs compactly in cards with links.
    Requires:
    - At least one section with tile and a list of links (but no more than four)
    - Choice of background color for banner
-->

<template>
  <main :class="`${this.block.value.color.color_choice}-color`">
    <mdb-container fluid>
      <mdb-row class="py-5 px-2">
        <mdb-col>
          <mdb-container>

            <!--Title and text (optional)-->

            <mdb-row v-if="block.value.title_and_text">
              <mdb-col>
                <h2 v-if="block.value.title_and_text.title" class="text-center pb-2">
                  <strong>{{block.value.title_and_text.title}}</strong>
                </h2>
                <p
                  v-if="block.value.title_and_text.text"
                  class="text-center"
                >{{block.value.title_and_text.text}}</p>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col>

                <!--For each quick link card, render the links and their categories-->

                <mdb-card-group deck class="m-1">
                  <mdb-card
                    class="z-depth-2"
                    v-for="card in block.value.quick_link_section"
                    :key="card.id"
                  >
                    <mdb-card-header class="text-left">{{card.value.title}}</mdb-card-header>
                    <mdb-card-body>
                      <ul class="list-unstyled">
                        <li
                          class="text-left"
                          v-for="link in card.value.links"
                          :key="link.id"
                        >

                          <!--If type is not document, then a non-null page or URL will be chosen (in that order)-->

                          <p v-if="link.type == 'category_name'" class="official-skin default-color mt-2"><strong>{{link.value}}</strong></p>
                          <router-link
                            v-else-if="link.value.document != null"
                            :to="`/departmentdocument/${link.value.document.slug}`"
                            class="ml-4"
                            ><mdb-icon icon="file" class="mr-2"></mdb-icon>{{link.value.title}}
                          </router-link>
                          <router-link
                            v-else-if="link.value.page != null"
                            :to="`/${link.value.page.link_page}/${link.value.page.slug}`"
                            class="ml-4"
                            ><mdb-icon icon="link" class="mr-2"></mdb-icon>{{link.value.title}}
                          </router-link>
                          <a
                            v-else-if="link.value.url != ''"
                            :href="link.value.url"
                            target="_blank"
                            class="ml-4"
                            ><mdb-icon icon="link" class="mr-2"></mdb-icon>{{link.value.title}}
                          </a>
                        </li>
                      </ul>
                    </mdb-card-body>
                  </mdb-card>
                </mdb-card-group>
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <div :class="{ 'component-pattern': block.value.pattern.show_pattern}"></div>
  </main>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardHeader,
  mdbCardBody,
  mdbCardGroup,
  mdbIcon
} from "mdbvue";
export default {
  name: "quick_links",
  props: {
    block: Object,
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardGroup,
    mdbIcon
  },
};
</script>
